import type { FC, PropsWithChildren, ReactNode } from 'react';

import { AffineOtherPageLayout } from '../affine-other-page-layout';
import {
  authPageContainer,
  hideInSmallScreen,
} from './share.css';

// yoDEV: Replaced AFFiNE illustration with yoDEV branding
export const AuthPageContainer: FC<
  PropsWithChildren<{
    title?: ReactNode;
    subtitle?: ReactNode;
  }>
> = ({ children, title, subtitle }) => {
  return (
    <AffineOtherPageLayout>
      <div className={authPageContainer}>
        <div className="wrapper">
          <div className="content">
            <p className="title">{title}</p>
            <div className="subtitle">{subtitle}</div>
            {children}
          </div>
          <div className={hideInSmallScreen} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '300px'
          }}>
            <span style={{
              fontSize: '72px',
              fontWeight: 700,
              opacity: 0.15
            }}>yoDEV</span>
          </div>
        </div>
      </div>
    </AffineOtherPageLayout>
  );
};
